import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalEditSubPlanData } from './models/ModalEditSubPlanData';

@Component({
    selector: 'app-modal-edit-subplan-item',
    templateUrl: './modal-edit-subplan-item.component.html',
    styleUrls: ['./modal-edit-subplan-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalEditSubplanItemComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: ModalEditSubPlanData) { }

  ngOnInit(): void {
  }

}
